import deleteGroupPopupController from '../components/group-delete-popup/am-group-delete-popup.component';
import deleteGroupPopupHtml from '../components/group-delete-popup/am-group-delete-popup.html';
import { AmGroup } from '../core/models/am-group.model';
// Required constants to filter and create groups
const roleId = '1295741015663050786';
const attrsName = 'onei3:feature';
const attrsValue = 'access.mgmt';
export default class AmGroupsService {
  constructor($q, $filter, securityGroupsService, groupsAPI, amAssetsService, $uibModal) {
    'ngInject';
    this.$filter = $filter;
    this.$q = $q;
    this.securityGroupService = securityGroupsService;
    this.accessAssetsService = amAssetsService;
    this.groupsAPI = groupsAPI;
    this.seviceResourceURl = this.securityGroupService.getResourceUrl();
    this.$uibModal = $uibModal;
  }
  createGroup(group) {
    // Hardcode for now the roleId
    group.roleId = roleId;
    return this.groupsAPI.sendInvite(group).then(res => res.data);
  }

  retrieveGroups() {
    return this.$q((resolve, reject) => {
      // Return a promise with the parsed groups
      this.securityGroupService
        .getAllSecurityGroups()
        .then(result => {
          const { data: groups = [] } = result.data;

          const accessManagementGroups = this.filterGroupsByAttrs(groups);
          return resolve(accessManagementGroups);
        })
        .catch(error => reject(error));
    });
  }
  filterGroupsByAttrs(groups) {
    return groups
      .filter(group => {
        const { attrs = {} } = group;
        return attrs[attrsName] && attrs[attrsName] === attrsValue;
      })
      .map(
        group =>
          new AmGroup({
            id: group.id,
            name: group.name,
            createdAt: group.createdAt,
            assets: [],
            attrs: group.attrs
          })
      );
  }

  getGroupById(id) {
    return this.$q((resolve, reject) => {
      this.securityGroupService
        .getSingleGroup(id)
        .then(result => {
          const { data: groupInfo } = result;
          const [groupUser = {}] = groupInfo.users;
          const { resources = [] } = groupInfo;

          let group = new AmGroup({
            id: groupInfo.id,
            name: groupInfo.name,
            email: groupUser.email || '',
            attrs: groupInfo.attrs || {},
            createdAt: groupInfo.createdAt,
            assets: []
          });

          if (resources.length === 0) return resolve(group);

          this.getAssetListByResources(resources)
            .then(result => (group.assets = result.assets || []))
            .finally(() => resolve(group));
        })
        .catch(error => reject(error));
    });
  }
  getAssetListByResources(resources) {
    const assetsIds = resources.reduce((accumulator, currentResource) => {
      const { type = '', id = '' } = currentResource;

      return type === 'equipment' && id !== '' ? [...accumulator, id] : [...accumulator];
    }, []);

    return this.accessAssetsService.getAssetListByIds(assetsIds);
  }

  updateGroupMetadata(id, group) {
    return this.securityGroupService.putGroupUpdate(id, group);
  }

  applyOperationAssets(assets, op = 'add') {
    return assets.map(asset => ({ op: op, value: { resource: this.seviceResourceURl + asset.id } }));
  }

  updateGroupAssets(id, assets, operation) {
    const payload = this.applyOperationAssets(assets, operation);
    return this.securityGroupService.patchEquipmentUserUpdate(id, payload);
  }

  openDeleteGroupPopup(group) {
    return this.$uibModal.open({
      animation: true,
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      template: deleteGroupPopupHtml,
      controller: deleteGroupPopupController,
      controllerAs: 'deletePopupVm',
      resolve: {
        group: () => group
      }
    }).result;
  }

  deleteGroup(id) {
    return this.securityGroupService.deleteGroup(id);
  }
}
